/* US region lock (display layer + optional hard redirect). When the visitor's
   detected country is not in window.KRegionLock.allowed: if KRegionLock.redirect
   holds an external http(s) URL they are sent there via location.replace;
   otherwise data-k-region-locked is set on <html> (out-of-stock treatment).
   Config is emitted by snippets/k-region-lock.liquid; presentation lives in
   kincrome-brand.css. Fail-open: any error leaves the site unlocked, because
   checkout already refuses non-US addresses (the real enforcement).
   Spec: docs/superpowers/specs/2026-07-06-us-region-lock-design.md */
(function () {
  var cfg = window.KRegionLock;
  if (!cfg || !Array.isArray(cfg.allowed) || cfg.allowed.length === 0) return;

  function apply(country) {
    if (cfg.allowed.indexOf(country) !== -1) return;
    // Redirect mode: only absolute http(s) URLs on a different host — blank,
    // relative, junk or same-store values fall back to the display lock, so a
    // mis-set URL can never create a redirect loop.
    if (cfg.redirect) {
      try {
        var dest = new URL(cfg.redirect);
        if ((dest.protocol === 'https:' || dest.protocol === 'http:') && dest.host !== window.location.host) {
          window.location.replace(dest.href);
          return;
        }
      } catch (e) {
        /* invalid URL — display lock below */
      }
    }
    document.documentElement.setAttribute('data-k-region-locked', '');
  }

  // Staff/test override: ?kregion=us forces US (unlocked) forever in this
  // browser; ?kregion=au previews the locked view; ?kregion=clear resets.
  // Values are trimmed/uppercased and only two-letter codes persist, so a
  // typo (?kregion=usa, stray %20) is a no-op rather than an operator trap.
  try {
    var q = new URLSearchParams(window.location.search).get('kregion');
    if (q) q = q.trim().toUpperCase();
    if (q === 'CLEAR') {
      localStorage.removeItem('k-region-override');
    } else if (q && /^[A-Z]{2}$/.test(q)) {
      localStorage.setItem('k-region-override', q);
    }
    var override = localStorage.getItem('k-region-override');
    if (override) {
      apply(override);
      return;
    }
  } catch (e) {
    /* storage blocked — fall through to detection */
  }

  try {
    var cached = sessionStorage.getItem('k-region-country');
    if (cached) {
      apply(cached);
      return;
    }
  } catch (e) {
    /* storage blocked — detection just runs on every page view */
  }

  fetch('/browsing_context_suggestions.json')
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (data) {
      var country = data &&
        data.detected_values &&
        data.detected_values.country &&
        data.detected_values.country.handle;
      if (!country) return; // unexpected shape — fail open, retry next page view
      try {
        sessionStorage.setItem('k-region-country', country);
      } catch (e) { /* ignore */ }
      apply(country);
    })
    .catch(function () {
      /* network/geo failure — fail open */
    });
})();
